module.exports = __webpack_public_path__ + "samsung_C49J890DKU_icon.svg?42b9469eaf2d4ccf0c981b4c9dd1560f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/samsung_C49J890DKU_icon.svg
// module id = 233
// module chunks = 0